import { Directive, HostListener, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[appClickableTooltip]'
})
export class ClickableTooltip {
  private matTooltip = inject(MatTooltip);

  constructor() { }

  @HostListener('click') onClick() {
    this.matTooltip.toggle();
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.matTooltip.toggle();
  }

}
